import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import {
  pushRecent,
  quickReactions,
  QUICK_REACTION_SLOTS,
  SKIN_TONES,
  type SkinTone,
} from '../lib/emoji';

// Emojis (M69, docs/emojis.md). All three belong to the device, like sounds
// and photo quality: nothing about what you pick leaves it.

/** "Recently used" in the picker, newest first, at most 24 (D263). */
export const recentEmojisAtom = atomWithStorage<string[]>(
  'twinden:recentEmojis',
  [],
  undefined,
  { getOnInit: true }
);

/** Your most recent reactions, for the quick row (D264). */
export const recentReactionsAtom = atomWithStorage<string[]>(
  'twinden:recentReactions',
  [],
  undefined,
  { getOnInit: true }
);

const storedToneAtom = atomWithStorage<string>(
  'twinden:emojiSkinTone',
  'none',
  undefined,
  { getOnInit: true }
);

/** The skin tone the picker applies (D263); anything unknown reads as none. */
export const skinToneAtom = atom(
  (get): SkinTone => {
    const value = get(storedToneAtom);
    return (SKIN_TONES as readonly string[]).includes(value)
      ? (value as SkinTone)
      : 'none';
  },
  (_get, set, tone: SkinTone) => set(storedToneAtom, tone)
);

/** Six quick reactions: recents first, then the D21 defaults (D264). */
export const quickReactionsAtom = atom((get) =>
  quickReactions(get(recentReactionsAtom))
);

/** Something was picked in the picker (either mode). */
export const rememberEmojiAtom = atom(null, (get, set, emoji: string) => {
  set(recentEmojisAtom, pushRecent(get(recentEmojisAtom), emoji));
});

/** A reaction was set (quick row, picker or a chip). */
export const rememberReactionAtom = atom(null, (get, set, emoji: string) => {
  set(
    recentReactionsAtom,
    pushRecent(get(recentReactionsAtom), emoji, QUICK_REACTION_SLOTS)
  );
});
